var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCasinoBets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17286_9711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.05 9C15.9833 7.6 15.4833 6.43333 14.55 5.5C13.6167 4.56667 12.45 4.06667 11.05 4H5.05C3.61667 4.06667 2.43334 4.56667 1.5 5.5C0.533336 6.46667 0.0500031 7.63333 0.0500031 9V19C0.0500031 20.4 0.533336 21.5833 1.5 22.55C2.46667 23.5167 3.65 24 5.05 24H11.05C12.4167 24 13.5833 23.5167 14.55 22.55C15.4833 21.6167 15.9833 20.4333 16.05 19V9ZM4.6 11.6C5.06667 11.2 5.55 11 6.05 11C6.51667 11 6.98334 11.2 7.45 11.6C7.84375 12.0594 8.04375 12.5094 8.05 12.95C8.05534 12.477 8.23868 12.027 8.6 11.6C9.06667 11.2 9.55 11 10.05 11C10.5167 11 10.9833 11.2 11.45 11.6C11.85 12.0667 12.05 12.5333 12.05 13C12.05 13.6667 11.75 14.45 11.15 15.35C10.6167 16.15 10 16.8333 9.3 17.4C8.96667 17.7 8.55 17.85 8.05 17.85C7.55 17.85 7.11667 17.7 6.75 17.4C6.08334 16.8333 5.48334 16.15 4.95 15.35C4.35 14.45 4.05 13.6667 4.05 13C4.05 12.5 4.23334 12.0333 4.6 11.6ZM23.8 8.2C24.2 6.86667 24.0667 5.6 23.4 4.4C22.8 3.23333 21.8333 2.43333 20.5 2L14.8 0.25C13.7667 -0.0499998 12.7667 -0.0333331 11.8 0.3C10.8333 0.6 10.0167 1.16667 9.35 2H11.05C13.0167 2.06667 14.65 2.76667 15.95 4.1C17.2833 5.4 17.9833 7.03333 18.05 9V19C18.05 19.9667 17.85 20.9 17.45 21.8C18.25 21.4667 18.8667 21.0333 19.3 20.5C19.8333 19.9 20.2 19.2667 20.4 18.6L23.8 8.2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17286_9711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCasinoBets);
export default __webpack_public_path__ + "static/media/icon-casino-bets.aa83f8996ff07a14ff232598e46e55da.svg";
export { ForwardRef as ReactComponent };